import type { ReactNode } from 'react';

import { styled } from 'styled-components';

const ContainerSC = styled.div`
  border: 1px solid ${(props) => props.theme.colors.slateGray[50]};
  padding: 1rem;
  display: flex;
`;

const MRZSC = styled.pre`
  white-space: pre-wrap;
  word-break: break-all;
  margin: 0;
  color: ${(props) => props.theme.colors.oxfordBlue[80]};
  font-size: 0.875rem;
  line-height: 1rem;
  font-family: OCRB, monospace;
`;

export type Props = {
  children: ReactNode;
  'data-test-id'?: string;
};

export const MrzArea = ({ children, 'data-test-id': dataTestId }: Props) => {
  return (
    <ContainerSC>
      <MRZSC data-test-id={dataTestId} dir="ltr">
        {children}
      </MRZSC>
    </ContainerSC>
  );
};
